import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { initialState } from '../initial';

export const resetAllProfiles = (create: ReducerCreators<AudiencesState>) =>
  create.reducer((state) => {
    state.allProfiles = initialState.allProfiles;
  });
